import { Component, OnInit, AfterViewInit, SystemJsNgModuleLoader, NgZone } from '@angular/core';
import { preserveWhitespacesDefault, debugOutputAstAsTypeScript } from '@angular/compiler';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../_services/app.service';
import { object, number } from '@amcharts/amcharts4/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { elementAt } from 'rxjs/operators';

declare var $: any;
declare var google: any;
@Component({
    selector: 'app-route-optimization',
    templateUrl: './route-optimization.component.html'
})
export class RouteOptimizationComponent implements OnInit, AfterViewInit {

    constructor(
        private toastr: ToastrService,
        private _appService: appService
    ) { }
    OrderPopUp: any = [];
    Address: any = [];
    OptimizeAddress: any = [];
    Orders: any = [];
    Vehicles: any = [];
    AddressesPoint: any = [];
    map: any;
    center: any;
    VehicleIds: any = [];
    Flag: any = false;
    public show_dialog: boolean = false;
    public button_name: any = 'Show Div!';
    status: boolean = false;
    btnstatus: boolean = false;
    Distance: any = [];
    Time: any = [];
    Customer: any = [];
    ContactNo: any = [];
    ContactName: any = [];
    totalDistance: any;
    LoadPer: number;
    ForRouteFlag: any;
    ngOnInit() {

    }

    AssignValueToPopup(element1: any, value: any) {

        this.OrderPopUp = [];
        this.ForRouteFlag = "";
        if (value == 'Primary') {
            this.ForRouteFlag = "Primary";
        }
        else if (value == 'Secondary') {
            this.ForRouteFlag = "Secondary";
        }
        else {
            this.ForRouteFlag = "LTL";
        }

        this.OrderPopUp.push(element1);
    }

    PrintData() {
        var divElements = document.getElementById('tblBS');
        var $iframe = $("<iframe>").appendTo("body");
        var printDiv = "<html style='font-family: calibri;border-style: solid;'><head><title> Route Details</title></head><body>" + divElements.innerHTML + "</body></html>";
        $iframe.contents().find('body').html(printDiv);
        var win = $iframe[0].contentWindow || $iframe[0];
        win.window.print();
        $iframe.remove();
    }

    toggle() {
        this.show_dialog = !this.show_dialog;
        this.status = !this.status;
        this.btnstatus = !this.btnstatus;
    }
    toggleMul(element1: any) {

        if (this.status = !this.status) {
            $(document.getElementById('div_' + element1.TransporterId)).css({ "display": "none" });
            $(document.getElementById('divMap_' + element1.TransporterId)).addClass("col-lg-12");
            $(document.getElementById('i_' + element1.TransporterId)).addClass("fa fa-arrow-right");
            this.status = true;
        }
        else {
            $(document.getElementById('div_' + element1.TransporterId)).css({ "display": "inline" });
            $(document.getElementById('divMap_' + element1.TransporterId)).removeClass();
            $(document.getElementById('divMap_' + element1.TransporterId)).addClass("col-lg-6");
            $(document.getElementById('i_' + element1.TransporterId)).removeClass();
            $(document.getElementById('i_' + element1.TransporterId)).addClass("fa fa-arrow-left");

        }
    }

    CheckUnchecked() {
        this.Address.forEach(element => {

            element.DisplayRoute = $("#DisplayRoute").prop('checked');
        });

        this.DisplayRoute();
    }
    CheckUncheckedMult(element1: any) {

        element1.PrimaryQuoteRoute.forEach(element => {
            element.DisplayRoute = $(document.getElementById('DisplayPRoute_' + element1.TransporterId)).prop('checked');
        });
        element1.SecondaryQuoteRoute.forEach(element => {
            element.DisplayRoute = $(document.getElementById('DisplayPRoute_' + element1.TransporterId)).prop('checked');
        });

        this.DisplayRouteOnSwitchChange(element1);

    }

    ngAfterViewInit() {
        this.map = new google.maps.Map(document.getElementById('map'), {
            center: { lat: 20.5937, lng: 78.9629 },
            zoom: 10
        });
    }

    DisplayRoute() {
        this.Flag = false;
        this.map = new google.maps.Map(document.getElementById('map'), {
            center: { lat: 20.5937, lng: 78.9629 },
            zoom: 10
        });
        // console.log(JSON.stringify(this.Address));
        this.initMap()
    }

    GetPath() {

        this.OptimizeAddress.forEach(element1 => {

            element1.PrimaryQuoteRoute.forEach(element => {
                element.DisplayRoute = true;
            });

            let mapObj = new google.maps.Map(document.getElementById('map'), {
                center: { lat: 20.5937, lng: 78.9629 },
                zoom: 11
            });

            this.SetPrimaryMapData(element1, mapObj);
        });

        // console.log(JSON.stringify(this.OptimizeAddress));
        // for (const key in this.OptimizeAddress) {
        //   if (this.OptimizeAddress.hasOwnProperty(key)) {

        //     const element = this.OptimizeAddress[key];
        //     var Add: any = {};
        //     //(Check Picked Vehicle) For picked vehicle this cond. will be true
        //     Add.DisplayRoute = true;
        //     if (element.route_distance != 0 && element.route_load != 0) {
        //       Add.Waypoints = [];
        //       Add.DataWaypoints = [];
        //       Add.route_load = parseFloat((element.route_load / 1000).toFixed(2));
        //       Add.route_distance = element.route_distance;

        //       //Sub-route
        //       let i: any = 65;
        //       if (element.subroute != undefined) {
        //         var d = parseInt(key);
        //         element.VehicleType = this.Vehicles[d];
        //         Add.VehicleType = element.VehicleType / 1000;
        //         Add.VehicleTypeString = element.VehicleType / 1000;
        //         Add.VehicleKGs = element.VehicleType;
        //         Add.VehicleId = this.VehicleIds[d];

        //         Add.QuoteId = this.OptimizeAddress.QuoteId;//element.QuoteId;
        //         Add.Distance = this.Distance[0];
        //         Add.totalDistance = this.Distance[0];
        //         Add.Time = this.Time[0];
        //         Add.LoadPer = parseFloat((((element.route_load / 1000) * 100) / (element.VehicleType / 1000)).toFixed(2));
        //         for (const key1 in element.subroute) {
        //           if (element.subroute.hasOwnProperty(key1)) {
        //             const element1 = element.subroute[key1];
        //             //Origin
        //             if (element1.index == 0 && element1.load == 0) {
        //               Add.Origin = element1.address;
        //               Add.OriginAdd = this.AddressesPoint[0];
        //               this.center = element1.address;
        //             }
        //             //Destination
        //             else if (element1.index == 0 && element1.load != 0) {
        //               Add.Destination = element1.address;
        //             }
        //             //Waypoints
        //             else {

        //               var w: any = {};
        //               w.location = element1.address;
        //               w.stopover = true;
        //               Add.Waypoints.push(w);
        //               var wd = $.extend({}, w, {});
        //               wd.MarkerValue = String.fromCharCode(i);
        //               wd.load = this.Orders[element1.index - 1].GrossWeight;
        //               wd.Volume = this.Orders[element1.index - 1].ProductVolume;
        //               wd.Quantity = this.Orders[element1.index - 1].Quantity;
        //               wd.OrderNo = this.Orders[element1.index - 1].SoNumber;
        //               wd.location = this.Orders[element1.index - 1].Address;
        //               wd.OrderId = this.Orders[element1.index - 1].OrderId;
        //               wd.Customer = this.Orders[element1.index - 1].Customer;
        //               wd.ContactNo = this.Orders[element1.index - 1].ContactNo;
        //               wd.ContactName = this.Orders[element1.index - 1].ContactName;

        //               wd.DistancePopup = this.Distance[element1.index - 1];
        //               wd.TimePopup = this.Time[element1.index - 1];
        //               wd.DistanceD = this.Distance[element1.index];
        //               wd.TimeT = this.Time[element1.index];
        //               Add.DataWaypoints.push(wd);
        //             }

        //             Add.MarkerValue = String.fromCharCode(i);
        //           }
        //           i++;
        //         }

        //         Add.PNoOfOrders = Add.DataWaypoints.length;
        //         var Dist: number = Add.DataWaypoints.reduce((sum, current) => sum + (current.DistanceD == undefined ? 0 : current.DistanceD), 0) + Add.Distance;
        //         Add.TotalDistance = parseFloat((Dist).toFixed(2));
        //         this.Address.push(Add);
        //       }

        //     }
        //   }
        // }

        // this.initMap();
        // setTimeout(() => {
        //   this.map.setCenter(new google.maps.LatLng(this.center));
        //   this.map.setZoom(7);
        // }, 1000);


    }

    ClearData() {
        this.Address = [];
        this.OptimizeAddress = [];
        this.Orders = [];
        this.Vehicles = [];
        this.AddressesPoint = [];
    }

    initMap() {
        let i = 0;
        this.Address.forEach(element => {
            element.VehicleSrNo = i + 1;
            if (element.DisplayRoute == true) {
                if (i == 0) {
                    element.Color = "#FF776B";
                    element.MarkerColor = "FF776B";
                }
                if (i == 1) {
                    element.Color = "#4eb64e";
                    element.MarkerColor = "4eb64e";
                }
                if (i == 2) {
                    element.Color = "#0070c0";
                    element.MarkerColor = "0070c0";
                }
                if (i == 3) {
                    element.Color = "#ff8014";
                    element.MarkerColor = "ff8014";
                }
                element.NoOfOrder = element.DataWaypoints.length;
                element.TotalLoad = element.DataWaypoints.reduce((sum, current) => sum + current.load, 0);

                var directionsService = new google.maps.DirectionsService;
                var directionsDisplay = new google.maps.DirectionsRenderer;

                var _that = this;
                directionsDisplay = new google.maps.DirectionsRenderer({
                    polylineOptions: {
                        strokeColor: element.Color
                    }, suppressMarkers: true
                });
                directionsDisplay.setMap(this.map);
                directionsService.route({
                    origin: element.Origin,
                    destination: element.Destination,
                    waypoints: element.Waypoints,
                    optimizeWaypoints: false,
                    travelMode: 'DRIVING'
                }, function (response, status) {
                    if (status === 'OK') {
                        directionsDisplay.setDirections(response);

                        let i: any = 65;
                        response.routes[0].legs.forEach(elementdd => {

                            var Char = String.fromCharCode(i);
                            var markerA = new google.maps.Marker({
                                position: elementdd.start_location,
                                title: elementdd.start_address,
                                map: _that.map,
                                icon: 'https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=' + Char + '|' + element.MarkerColor + '|000000',
                            });
                            i++;
                        });
                    } else {
                        console.log('Directions request failed due to ' + status);
                        // window.alert('Directions request failed due to ' + status);
                    }
                });
            }
            i++;
        });
        this.SaveOrderBrackdown();
    }

    OnCreateBooking(d, VehicleSrNo, QuoteId) {

        this._appService.GetByThreeId("Quote", "CreateBookingFromQuote", QuoteId, VehicleSrNo, null).subscribe(response => {
            $("#BtnCreateBooking_" + d).prop('disabled', true);
            this.toastr.success("Booking Created Successfully !", 'Success');
        }, err => {
            console.log("Error occured While Saving Brackdown data !");
        });
    }


    SaveOrderBrackdown() {
        let i = 0;
        var OrderbrackDown: any = [];
        this.Address.forEach(element => {
            element.DataWaypoints.forEach(element1 => {
                var data: any = {};
                data.VehicalSrNo = i + 1;
                data.QuoteId = element.QuoteId;
                data.VehicleId = element.VehicleId;
                data.VehicleKGs = element.VehicleKGs;
                data.OrderType = "OrderByProduct"
                data.OrderId = element1.OrderId;
                data.Quantity = element1.Quantity;
                data.GrossWeight = element1.load;
                data.ProductVolume = element1.Volume;
                OrderbrackDown.push(data);
            });
            i++;
        });

        // console.log(JSON.stringify(OrderbrackDown));
        this._appService.Post("Quote", "SaveOrderBrackDown", OrderbrackDown).subscribe(response => {
        }, err => {
            console.log("Error occured While Saving Brackdown data !");
        });
    }

    GetTransWiseRouteOpti() {
        this.Flag = true;
        setTimeout(() => {
            this.GetTransWiseRouteOptiCall();
        }, 500);
    }

    GetTransWiseRouteOptiCall() {


        this.OptimizeAddress.forEach(element1 => {

            element1.PrimaryQuoteRoute.forEach(element => {
                element.DisplayRoute = true;
            });
            element1.SecondaryQuoteRoute.forEach(element => {
                element.DisplayRoute = true;
            });

            let mapObj = new google.maps.Map(document.getElementById('OptPrimaryMap_' + element1.TransporterId), {
                center: { lat: 20.5937, lng: 78.9629 },
                zoom: 11
            });

            this.SetPrimaryMapData(element1, mapObj);
            this.SetSeconaryMapData(element1, mapObj);
        });
    }

    SetPrimaryMapData(element1: any, mapObj: any) {
        let j = 0;
        element1.PrimaryQuoteRoute.forEach(element => {
            element.VehicleSrNo = j + 1;
            if (element.DisplayRoute == true) {
                if (j == 0) {
                    element.Color = "#FF776B";
                    element.MarkerColor = "FF776B";
                }
                else if (j == 1) {
                    element.Color = "#4eb64e";
                    element.MarkerColor = "4eb64e";
                }
                else if (j == 2) {
                    element.Color = "#0070c0";
                    element.MarkerColor = "0070c0";
                }
                else {
                    element.Color = "#ff8014";
                    element.MarkerColor = "ff8014";
                }

                // element.DisplayRoute = true;
                let i: any = 66;
                element.PrimaryDataWaypoints = [];

                element.Route.forEach(ele => {

                    var wd: any = {};
                    wd.MarkerValue = String.fromCharCode(i);
                    wd.load = ele.Load;
                    wd.Volume = ele.Volume;
                    wd.Quantity = ele.Quantity;
                    wd.OrderNo = ele.OrderNo;
                    wd.location = ele.DeliveryAddress;
                    wd.OrderId = "";
                    wd.CustomerType = ele.CustomerType;
                    wd.Distance = ele.Distance;
                    wd.Time = ele.Duration;

                    wd.Customer = ele.Customer;
                    wd.ContactName = ele.ContactName;
                    wd.ContactNo = ele.ContactNo;
                    wd.VehicleType = ele.VehicleType;
                    element.VehicleType = ele.VehicleType;
                    element.VehicleVolume = element.VehicleVolume;
                    element.PrimaryDataWaypoints.push(wd);
                    i++;
                });
                element.Customer_Type = element.PrimaryDataWaypoints[0].CustomerType

                element.OriginAdd = element1.PrimaryOriginAddress;
                element.route_load = element.PrimaryDataWaypoints.reduce((sum, current) => sum + current.load, 0);
                element.route_load = parseFloat((element.route_load / 1000).toFixed(2));
                element.route_volume = element.PrimaryDataWaypoints.reduce((sum, current) => sum + current.Volume, 0);
                element.route_volume = parseFloat((element.route_volume).toFixed(2));

                var Dist: number = element.PrimaryDataWaypoints.reduce((sum, current) => sum + current.Distance, 0);
                element.TotalDistance = parseFloat((Dist).toFixed(2));

                element.VehicleTypeString = element.VehicleType;
                element.VehicleTypeString = element.VehicleTypeString.slice(0, -3);
                element.LoadPer = parseFloat((((element.route_load) * 100) / parseFloat(element.VehicleTypeString)).toFixed(2));
                element.VolumePer = parseFloat((((element.route_volume) * 100) / parseFloat(element.VehicleVolume)).toFixed(2));

                element.Waypoints = element.Route.map(function (a) { return { location: a.LatLong, stopover: true } });
                element.PNoOfOrders = element.PrimaryDataWaypoints.length;
                let directionsService = new google.maps.DirectionsService;
                let directionsDisplay = new google.maps.DirectionsRenderer({
                    polylineOptions: {
                        strokeColor: element.Color
                    }, suppressMarkers: true
                });
                directionsDisplay.setMap(mapObj);
                directionsService.route({
                    origin: element1.PrimaryOrigin,
                    destination: element1.PrimaryDestination,
                    waypoints: element.Waypoints,
                    optimizeWaypoints: false,
                    travelMode: 'DRIVING'
                }, function (response, status) {
                    if (status === 'OK') {
                        directionsDisplay.setDirections(response);

                        let i: any = 65;
                        response.routes[0].legs.forEach(elementdd => {
                            var Char = String.fromCharCode(i);

                            var markerA = new google.maps.Marker({
                                position: elementdd.start_location,
                                title: elementdd.start_address,
                                map: mapObj,
                                icon: 'https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=' + Char + '|' + element.MarkerColor + '|000000',
                            });
                            i++;
                        });
                    } else {
                        console.log('Directions request failed due to ' + status);
                        // window.alert('Directions request failed due to ' + status);
                    }
                });
            }
            j++;
        });
    }

    SetSeconaryMapData(element1: any, mapObj: any) {

        let j = 0;
        element1.SecondaryQuoteRoute.forEach(element => {
            element.VehicleSrNo = j + 1;
            if (element.DisplayRoute == true) {
                if (j == 0) {
                    element.Color = "#FF776B";
                    element.MarkerColor = "FF776B";
                }
                else if (j == 1) {
                    element.Color = "#4eb64e";
                    element.MarkerColor = "4eb64e";
                }
                else if (j == 2) {
                    element.Color = "#0070c0";
                    element.MarkerColor = "0070c0";
                }
                else if (j == 3) {
                    element.Color = "#ff8014";
                    element.MarkerColor = "ff8014";
                }
                else if (j == 4) {
                    element.Color = "#880be1";
                    element.MarkerColor = "880be1";
                }
                else if (j == 5) {
                    element.Color = "#0ebfd4";
                    element.MarkerColor = "0ebfd4";
                }
                else if (j == 6) {
                    element.Color = "#df678c";
                    element.MarkerColor = "df678c";
                }
                else if (j == 7) {
                    element.Color = "#aab25ac2";
                    element.MarkerColor = "aab25ac2";
                }

                element.DisplayRoute = true;
                let i: any = 66;
                element.SecondaryDataWaypoints = [];

                element.Route.forEach(ele => {

                    var wd: any = {};
                    wd.MarkerValue = String.fromCharCode(i);
                    wd.load = ele.Load;
                    wd.Volume = ele.Volume;
                    wd.Quantity = ele.Quantity;
                    wd.OrderNo = ele.OrderNo;
                    wd.location = ele.DeliveryAddress;
                    wd.OrderId = "";
                    wd.CustomerType = ele.CustomerType;
                    wd.Distance = ele.Distance;
                    wd.Time = ele.Duration;
                    // wd.OriginAdd = element1.SecondaryOriginAddress;
                    wd.Customer = ele.Customer;
                    wd.ContactName = ele.ContactName;
                    wd.ContactNo = ele.ContactNo;
                    element.VehicleType = ele.VehicleType;
                    element.VehicleVolume = element.VehicleVolume;
                    element.SecondaryDataWaypoints.push(wd);
                    i++;
                });

                element.Customer_Type = element.SecondaryDataWaypoints[0].CustomerType
                element.route_load = element.SecondaryDataWaypoints.reduce((sum, current) => sum + current.load, 0);
                element.route_load = parseFloat((element.route_load / 1000).toFixed(2));
                element.route_volume = element.SecondaryDataWaypoints.reduce((sum, current) => sum + current.Volume, 0);
                element.route_volume = parseFloat((element.route_volume).toFixed(2));

                var Dist: number = element.SecondaryDataWaypoints.reduce((sum, current) => sum + current.Distance, 0);
                element.TotalDistance = parseFloat((Dist).toFixed(2));
                element.VehicleTypeString = element.VehicleType;
                element.VehicleTypeString = element.VehicleTypeString.slice(0, -3);
                element.Waypoints = element.Route.map(function (a) { return { location: a.LatLong, stopover: true } });
                element.LoadPer = parseFloat(((element.route_load * 100) / parseFloat(element.VehicleTypeString)).toFixed(2));
                element.VolumePer = parseFloat((((element.route_volume) * 100) / parseFloat(element.VehicleVolume)).toFixed(2));
                element.PNoOfOrders = element.SecondaryDataWaypoints.length;
                element.OriginAdd = element1.SecondaryOriginAddress
                let directionsService = new google.maps.DirectionsService;
                let directionsDisplay = new google.maps.DirectionsRenderer({
                    polylineOptions: {
                        strokeColor: element.Color
                    }, suppressMarkers: true
                });
                directionsDisplay.setMap(mapObj);
                directionsService.route({
                    origin: element1.SecondaryOrigin,
                    destination: element1.SecondaryDestination,
                    waypoints: element.Waypoints,
                    optimizeWaypoints: false,
                    travelMode: 'DRIVING'
                }, function (response, status) {
                    if (status === 'OK') {
                        directionsDisplay.setDirections(response);

                        let i: any = 65;
                        response.routes[0].legs.forEach(elementdd => {
                            var Char = String.fromCharCode(i);

                            var markerA = new google.maps.Marker({
                                position: elementdd.start_location,
                                title: elementdd.start_address,
                                map: mapObj,
                                icon: 'https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=' + Char + '|' + element.MarkerColor + '|000000',
                            });
                            i++;
                        });
                    } else {
                        console.log('Directions request failed due to ' + status);
                        // window.alert('Directions request failed due to ' + status);
                    }
                });
            }
            j++;
        });
    }

    DisplayRouteOnSwitchChange(element1: any) {
        let mapObj = new google.maps.Map(document.getElementById('OptPrimaryMap_' + element1.TransporterId), {
            center: { lat: 20.5937, lng: 78.9629 },
            zoom: 15
        });
        this.SetPrimaryMapData(element1, mapObj);
        this.SetSeconaryMapData(element1, mapObj);
    }

}




